module.exports = __webpack_public_path__ + "images/backgrounds/river/large.14f3d47be57d27a56136.jpg";